import type { DomApplier } from '../cssFeatures.types'
import { getVariantKey, getVariantSelectors } from '../../utils/variantsUtils'
import type { SelectorToCssString } from '../../shared.types'

export const presetsDomApplier: DomApplier<'presets'> = (
	{ id: compId },
	idSelector,
	breakpointId,
	{ presetsOutput },
	cssContext
) => {
	if (!presetsOutput) {
		return null
	}
	const { presets, supportExternalDependenciesCss } = presetsOutput

	const domApplierOutput: SelectorToCssString = {}

	for (const selectorKey in presets) {
		const presetInBp = presets[selectorKey]?.[breakpointId]

		if (presetInBp) {
			presetInBp.reduce((acc: SelectorToCssString, presetData) => {
				const { presetCss, variants } = presetData

				const rootWrapperSelector: string = getVariantSelectors(
					getVariantKey(variants),
					variants,
					compId,
					cssContext,
					{
						shouldTargetBuilderWrapper: true,
						supportExternalDependenciesCss
					}
				).join(',')

				let selector: string
				if (selectorKey === 'root') {
					selector = rootWrapperSelector
				} else {
					selector = supportExternalDependenciesCss ? selectorKey : `${rootWrapperSelector} ${selectorKey}`
				}

				const presetCssWithSelector = `${selector}{${presetCss as string}}`

				if (acc[selector]) {
					acc[selector] += presetCssWithSelector
				} else {
					acc[selector] = presetCssWithSelector
				}
				return acc
			}, domApplierOutput)
		}
	}

	return Object.keys(domApplierOutput).length ? domApplierOutput : null
}
